import format from "date-fns/format";
import tr from "date-fns/locale/tr";
import { useSearchParams } from "next/navigation";
import React, { useContext, useEffect, useState } from "react";

export const DetailContext = React.createContext(null);

export const start = new Date();
// export const end = new Date().setDate(new Date().getDate() + 5);
// eslint-disable-next-line react/display-name
const DetailProvider = ({ children }) => {
  const searchParams = useSearchParams();

  const [enquiryForm, setEnquiryForm] = useState({
    ProductId: null,
    start: null,
    end: null,
    yetiskin: null,
    cocuk: null,
    bebek: null,
  });

  const initialFilterForm = {
    start: format(start, "yyyy-MM-dd", { locale: tr }),
    end: format(start, "yyyy-MM-dd", { locale: tr }),
    yetiskin: 0,
    tip: [],
    bolge: [],
    min: "",
    max: "",
    rule: 0,
    specify: [],
  };

  const [filterForm, setFilterForm] = useState(initialFilterForm);
  const [selectedDatesFilter, setSelectedDatesFilter] = useState([
    {
      startDate: start,
      endDate: start,
      key: "selection",
      isShow: 0,
    },
  ]);

  useEffect(() => {
    setEnquiryForm((prev) => {
      return {
        ...prev,
        start: format(selectedDatesFilter[0]?.startDate, "yyyy-MM-dd", {
          locale: tr,
        }),
        end: format(selectedDatesFilter[0]?.endDate, "yyyy-MM-dd", {
          locale: tr,
        }),
      };
    });
  }, [selectedDatesFilter]);

  useEffect(() => {
    const startDate = searchParams.get("start");
    const endDate = searchParams.get("end");

    setFilterForm({
      ...filterForm,
      start: startDate,
      end: endDate,
    });
    setSelectedDatesFilter([
      {
        startDate: startDate ? new Date(startDate) : start,
        endDate: endDate ? new Date(endDate) : start,
        key: "selection",
        isShow: 0,
      },
    ]);
  }, [searchParams]);

  const value = {
    filterForm,
    setFilterForm,
    selectedDatesFilter,
    setSelectedDatesFilter,
    enquiryForm,
    setEnquiryForm,
  };

  return (
    <DetailContext.Provider value={value}>{children}</DetailContext.Provider>
  );
};

export default DetailProvider;

export function useDetailContext() {
  const context = useContext(DetailContext);
  if (!context) {
    throw new Error(
      "useStoreContext bir StoreContextProvider içinde kullanılmalıdır"
    );
  }
  return context;
}
